import React from "react";
import axios from "axios";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
} from "reactstrap";
import { WAVE_USERS_URL } from "../actions/types";
import ErrorAlert from "../components/Modals/ErrorAlert";
import SuccessAlert from "../components/Modals/SuccessAlert";
import { Spinner } from "reactstrap";
import InfoAlert from "../components/Modals/InfoAlert";

export default function RegisterModal({
  registerModalOpen,
  toggleRegisterModal,
}) {
  const [loading, setLoading] = React.useState(false);
  const [registerForm, setRegisterForm] = React.useState({
    username: "",
    first_name: "",
    last_name: "",
    organization: "",
    email: "",
    email_confirmation: "",
    password: "",
    password_confirmation: "",
    platform_wave: false,
    platform_offshore: false,
    platform_res: false,
  });
  console.log(registerForm)
  const submitForm = (e) => {
    e.preventDefault();
    if (registerForm.password.length < 8) {
      InfoAlert("The length of the password cannot be less than 8 characters");
    } else {
      if (loading === false) {
        setLoading(true);
        axios
          .post(WAVE_USERS_URL + "wave_registration/", registerForm)
          .then((res) => {
            toggleRegisterModal();
            setRegisterForm({
              username: "",
              first_name: "",
              last_name: "",
              organization: "",
              email: "",
              email_confirmation: "",
              password: "",
              password_confirmation: "",
              platform_wave: false,
              platform_offshore: false,
              platform_res: false,
            });
            setLoading(false);
            SuccessAlert("Account created");
          })
          .catch((error) => {
            setLoading(false);
            ErrorAlert(error.response.data.detail);
          });
      }
    }
  };

  return (
    <Modal
      isOpen={registerModalOpen}
      toggle={toggleRegisterModal}
      centered={true}
      size="lg"
      className="modalLogin"
    >
      <ModalHeader toggle={toggleRegisterModal}>Form</ModalHeader>
      <ModalBody>
        <Form id="registration-form" onSubmit={submitForm}>
          <FormGroup row>
            <Label for="form-username" sm={4}>
              Username
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.username}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="text"
                name="username"
                id="form-username"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-firstname" sm={4}>
              First name
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.first_name}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="text"
                name="first_name"
                id="form-firstname"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-lastname" sm={4}>
              Last name
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.last_name}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="text"
                name="last_name"
                id="form-lastname"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-organization" sm={4}>
              Organization
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.organization}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="text"
                name="organization"
                id="form-organization"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-email" sm={4}>
              Email
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.email}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="email"
                name="email"
                id="form-email"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-email-confirmation" sm={4}>
              Email Confirmation
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.email_confirmation}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="email"
                name="email_confirmation"
                id="form-email-confirmation"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-password" sm={4}>
              Password
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.password}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="password"
                name="password"
                id="form-password"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <br />
          <FormGroup row>
            <Label for="form-passowrd-confirmation" sm={4}>
              Password Confirmation
            </Label>
            <Col sm={8}>
              <Input
                value={registerForm.password_confirmation}
                onChange={(e) =>
                  setRegisterForm({
                    ...registerForm,
                    [e.target.name]: e.target.value,
                  })
                }
                type="password"
                name="password_confirmation"
                id="form-passowrd-confirmation"
                placeholder=""
                required
              />
            </Col>
          </FormGroup>
          <div style={{ marginTop: 27, marginBottom: 10 }}>
            <div style={{ display: "inline", marginRight: 186 }}>
              Register to
            </div>
            <FormGroup
              check
              inline
              style={{ cursor: "not-allowed" }}
            >
              <Label check>
                <Input
                  type="checkbox"
                  name="platform_res"
                  checked={registerForm.res}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      [e.target.name]: e.target.checked,
                    })
                  }
                />{" "}
                RES
              </Label>
            </FormGroup>
            <FormGroup
              check
              inline
              style={{ cursor: "not-allowed" }}
              onClick={() =>
                InfoAlert("Non è possibile iscriversi alla piattaforma OIL")
              }
            >
              <Label check style={{ color: "#BBBBBB", cursor: "not-allowed" }}>
                <Input
                  type="checkbox"
                  name="platform_offshore"
                  checked={false}
                  disabled={true}
                />{" "}
                OIL
              </Label>
            </FormGroup>
            <FormGroup
              check
              inline
              style={{ cursor: "not-allowed" }}
              onClick={() =>
                InfoAlert("Non è possibile iscriversi alla piattaforma ET@IT")
              }
            >
              <Label check style={{ color: "#BBBBBB", cursor: "not-allowed" }}>
                <Input
                  type="checkbox"
                  name="platform_offshore"
                  checked={false}
                  disabled={true}
                />{" "}
                ET@IT
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input
                  type="checkbox"
                  name="platform_wave"
                  checked={registerForm.wave}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      [e.target.name]: e.target.checked,
                    })
                  }
                />{" "}
                Wave
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input
                  type="checkbox"
                  name="platform_offshore"
                  checked={registerForm.offshore}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      [e.target.name]: e.target.checked,
                    })
                  }
                />{" "}
                Offshore Wind
              </Label>
            </FormGroup>
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        {loading === true ? (
          <Button
            color="primary"
            type="submit"
            form="registration-form"
            style={{ minWidth: 130 }}
          >
            <Spinner size="sm"> </Spinner>
          </Button>
        ) : (
          <Button
            color="primary"
            type="submit"
            form="registration-form"
            style={{ minWidth: 130 }}
          >
            Register
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}
